import { render } from "./HomeCategoryBoxes.vue?vue&type=template&id=5534e4b3&lang=pug"
import script from "./HomeCategoryBoxes.vue?vue&type=script&lang=js"
export * from "./HomeCategoryBoxes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__